"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var image_asset_1 = require("../../image-asset/image-asset");

exports.ApplicationHeaderLogo = function () {
  return react_1.default.createElement(image_asset_1.ImageAsset, {
    resizeMode: "contain",
    name: "headerPrescryptiveTrademarkLogo",
    style: styles.imageStyle
  });
};

var imageStyle = {
  flex: 1,
  flexGrow: 0,
  height: 60
};
var styles = react_native_1.StyleSheet.create({
  imageStyle: imageStyle
});